<div class="row" [formGroup]="patientForm" style="margin-top: 10px">
  <!-- Physical & Lifestyle Section -->
  <div class="col-12">
    <div class="card bg-darker p-5">
      <div class="card-title text-white mb-2 d-flex align-items-center">
        <i class="fs-5 me-2 fas fa-heartbeat"></i>
        <h5 class="mb-0">
          {{ "patientCreate.physicalLifestyle.title" | translate }}
        </h5>
      </div>
      <p class="text-light fs-12 mb-4 opacity-75">
        {{ "patientCreate.physicalLifestyle.description" | translate }}
      </p>

      <div class="row g-3" [formGroup]="patientForm.get('physicalLifestyle')">
        <!-- Height -->
        <div class="col-md-6">
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.height" | translate }}
          </label>
          <input
            type="text"
            inputmode="decimal"
            appDecimalOnly
            class="form-control bg-dark border-secondary text-light"
            [placeholder]="'patientCreate.form.heightPlaceholder' | translate"
            formControlName="height"
            (blur)="formatPhysicalInput('height')"
            [class.is-invalid]="
              patientForm.get('physicalLifestyle.height')?.invalid &&
              patientForm.get('physicalLifestyle.height')?.touched
            "
          />
          <div
            class="text-danger fs-12 mt-1"
            *ngIf="
              patientForm.get('physicalLifestyle.height')?.invalid &&
              patientForm.get('physicalLifestyle.height')?.touched
            "
          >
            <span
              *ngIf="
                patientForm.get('physicalLifestyle.height')?.hasError('min')
              "
            >
              {{ "patientCreate.validation.minHeight" | translate }} (50cm)
            </span>
            <span
              *ngIf="
                patientForm.get('physicalLifestyle.height')?.hasError('max')
              "
            >
              {{ "patientCreate.validation.maxHeight" | translate }} (250cm)
            </span>
          </div>
        </div>

        <!-- Weight -->
        <div class="col-md-6">
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.weight" | translate }}
          </label>
          <input
            type="text"
            inputmode="decimal"
            appDecimalOnly
            class="form-control bg-dark border-secondary text-light"
            [placeholder]="'patientCreate.form.weightPlaceholder' | translate"
            formControlName="weight"
            (blur)="formatPhysicalInput('weight')"
            [class.is-invalid]="
              patientForm.get('physicalLifestyle.weight')?.invalid &&
              patientForm.get('physicalLifestyle.weight')?.touched
            "
          />
          <div
            class="text-danger fs-12 mt-1"
            *ngIf="
              patientForm.get('physicalLifestyle.weight')?.invalid &&
              patientForm.get('physicalLifestyle.weight')?.touched
            "
          >
            <span
              *ngIf="
                patientForm.get('physicalLifestyle.weight')?.hasError('min')
              "
            >
              {{ "patientCreate.validation.minWeight" | translate }} (20kg)
            </span>
            <span
              *ngIf="
                patientForm.get('physicalLifestyle.weight')?.hasError('max')
              "
            >
              {{ "patientCreate.validation.maxWeight" | translate }} (300kg)
            </span>
          </div>
        </div>

        <!-- Waist Circumference -->
        <div class="col-md-6">
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.waistCircumference" | translate }}
          </label>
          <input
            type="text"
            inputmode="decimal"
            appDecimalOnly
            class="form-control bg-dark border-secondary text-light"
            [placeholder]="
              'patientCreate.form.waistCircumferencePlaceholder' | translate
            "
            formControlName="waistCircumference"
            (blur)="formatPhysicalInput('waistCircumference')"
            [class.is-invalid]="
              patientForm.get('physicalLifestyle.waistCircumference')
                ?.invalid &&
              patientForm.get('physicalLifestyle.waistCircumference')?.touched
            "
          />
          <div
            class="text-danger fs-12 mt-1"
            *ngIf="
              patientForm.get('physicalLifestyle.waistCircumference')
                ?.invalid &&
              patientForm.get('physicalLifestyle.waistCircumference')?.touched
            "
          >
            <span
              *ngIf="
                patientForm
                  .get('physicalLifestyle.waistCircumference')
                  ?.hasError('min')
              "
            >
              {{ "patientCreate.validation.minWaist" | translate }} (30cm)
            </span>
            <span
              *ngIf="
                patientForm
                  .get('physicalLifestyle.waistCircumference')
                  ?.hasError('max')
              "
            >
              {{ "patientCreate.validation.maxWaist" | translate }} (200cm)
            </span>
          </div>
        </div>

        <!-- Skin Type -->
        <div class="col-md-6">
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.skinType" | translate }}
          </label>
          <ng-select
            formControlName="skinType"
            [items]="skinTypeOptions"
            bindLabel="name"
            bindValue="id"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'patientCreate.form.skinType' | translate"
            appendTo="body"
            class="custom-select"
          >
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <div
                class="skin-type-option"
                [style.background-color]="item.color"
                [style.color]="item.textColor"
              >
                {{ item.name }}
              </div>
            </ng-template>
          </ng-select>
        </div>

        <!-- Living Conditions -->
        <div class="col-md-6">
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.livingConditions" | translate }}
          </label>
          <app-select
            formControlName="livingConditions"
            [items]="livingConditionsOptions"
            bindLabel="name"
            bindValue="id"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'patientCreate.form.livingConditions' | translate"
          ></app-select>
        </div>

        <!-- Physical Activity Level -->
        <div class="col-md-6">
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.physicalActivityLevel" | translate }}
          </label>
          <div class="d-flex gap-3 mt-2">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="physicalActivityLevel"
                id="sedentary"
                [value]="1"
                formControlName="physicalActivityLevel"
              />
              <label class="form-check-label text-light fs-12" for="sedentary">
                {{
                  "patientCreate.physicalLifestyle.activityLevels.sedentary"
                    | translate
                }}
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="physicalActivityLevel"
                id="moderate"
                [value]="2"
                formControlName="physicalActivityLevel"
              />
              <label class="form-check-label text-light fs-12" for="moderate">
                {{
                  "patientCreate.physicalLifestyle.activityLevels.moderate"
                    | translate
                }}
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="physicalActivityLevel"
                id="active"
                [value]="3"
                formControlName="physicalActivityLevel"
              />
              <label class="form-check-label text-light fs-12" for="active">
                {{
                  "patientCreate.physicalLifestyle.activityLevels.active"
                    | translate
                }}
              </label>
            </div>
          </div>
        </div>

        <!-- Diet Type -->
        <div class="col-md-6">
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.dietType" | translate }}
          </label>
          <app-select
            formControlName="dietType"
            [items]="dietTypeOptions"
            bindLabel="name"
            bindValue="id"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'patientCreate.form.dietType' | translate"
            appendTo="body"
          ></app-select>
        </div>

        <!-- Blood Type -->
        <div class="col-md-6">
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.bloodType" | translate }}
          </label>
          <app-select
            formControlName="bloodType"
            [items]="bloodTypeOptions"
            bindLabel="name"
            bindValue="id"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'patientCreate.form.bloodType' | translate"
            appendTo="body"
          ></app-select>
        </div>

        <!-- Alcohol Consumption -->
        <div class="col-md-6">
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.alcoholConsumption" | translate }}
          </label>
          <app-select
            formControlName="alcoholConsumption"
            [items]="alcoholConsumptionOptions"
            bindLabel="name"
            bindValue="id"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'patientCreate.form.alcoholConsumption' | translate"
            appendTo="body"
          ></app-select>
        </div>

        <!-- Smoking Status -->
        <div class="col-md-6">
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.smokingStatus" | translate }}
          </label>
          <app-select
            formControlName="smokingStatus"
            [items]="smokingStatusOptions"
            bindLabel="name"
            bindValue="id"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'patientCreate.form.smokingStatus' | translate"
            appendTo="body"
          ></app-select>
        </div>

        <!-- Alcohol Portion Per Day (Conditional) -->
        <div
          class="col-md-6"
          *ngIf="
            patientForm.get('physicalLifestyle.alcoholConsumption')?.value !==
              null &&
            patientForm.get('physicalLifestyle.alcoholConsumption')?.value !== 0
          "
        >
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.alcoholPortionPerDay" | translate }}
          </label>
          <input
            type="number"
            class="form-control bg-dark border-secondary text-light"
            placeholder="Enter portions per day"
            formControlName="alcoholPortionPerDay"
            [class.is-invalid]="
              patientForm.get('physicalLifestyle.alcoholPortionPerDay')
                ?.invalid &&
              patientForm.get('physicalLifestyle.alcoholPortionPerDay')?.touched
            "
          />
          <div
            class="text-danger fs-12 mt-1"
            *ngIf="
              patientForm.get('physicalLifestyle.alcoholPortionPerDay')
                ?.invalid &&
              patientForm.get('physicalLifestyle.alcoholPortionPerDay')?.touched
            "
          >
            <span
              *ngIf="
                patientForm
                  .get('physicalLifestyle.alcoholPortionPerDay')
                  ?.hasError('pattern')
              "
            >
              {{ "patientCreate.validation.patternNumber" | translate }}
            </span>
          </div>
        </div>

        <!-- Smoking Duration (Conditional) -->
        <div
          class="col-md-3"
          [ngClass]="{
            'offset-md-6': !(
              patientForm.get('physicalLifestyle.alcoholConsumption')?.value !==
                null &&
              patientForm.get('physicalLifestyle.alcoholConsumption')?.value !==
                0
            ),
          }"
          *ngIf="
            patientForm.get('physicalLifestyle.smokingStatus')?.value === 1 ||
            patientForm.get('physicalLifestyle.smokingStatus')?.value === 2
          "
        >
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.smokingDuration" | translate }}
          </label>
          <input
            type="number"
            class="form-control bg-dark border-secondary text-light"
            placeholder="Enter duration in years"
            formControlName="smokingDuration"
            [class.is-invalid]="
              patientForm.get('physicalLifestyle.smokingDuration')?.invalid &&
              patientForm.get('physicalLifestyle.smokingDuration')?.touched
            "
          />
          <div
            class="text-danger fs-12 mt-1"
            *ngIf="
              patientForm.get('physicalLifestyle.smokingDuration')?.invalid &&
              patientForm.get('physicalLifestyle.smokingDuration')?.touched
            "
          >
            <span
              *ngIf="
                patientForm
                  .get('physicalLifestyle.smokingDuration')
                  ?.hasError('pattern')
              "
            >
              {{ "patientCreate.validation.patternNumber" | translate }}
            </span>
          </div>
        </div>

        <!-- Smoking Amount (Conditional) -->
        <div
          class="col-md-3"
          *ngIf="
            patientForm.get('physicalLifestyle.smokingStatus')?.value === 2
          "
        >
          <label class="form-label text-light fs-12 mb-1">
            {{ "patientCreate.form.smokingAmount" | translate }}
          </label>
          <input
            type="number"
            class="form-control bg-dark border-secondary text-light"
            placeholder="Enter cigarettes per day"
            formControlName="smokingAmount"
            [class.is-invalid]="
              patientForm.get('physicalLifestyle.smokingAmount')?.invalid &&
              patientForm.get('physicalLifestyle.smokingAmount')?.touched
            "
          />
          <div
            class="text-danger fs-12 mt-1"
            *ngIf="
              patientForm.get('physicalLifestyle.smokingAmount')?.invalid &&
              patientForm.get('physicalLifestyle.smokingAmount')?.touched
            "
          >
            <span
              *ngIf="
                patientForm
                  .get('physicalLifestyle.smokingAmount')
                  ?.hasError('pattern')
              "
            >
              {{ "patientCreate.validation.patternNumber" | translate }}
            </span>
          </div>
        </div>

        <!-- Pack-Year Calculation -->
        <div
          class="col-12 mt-3 text-end"
          *ngIf="
            patientForm.get('physicalLifestyle.smokingAmount')?.value &&
            patientForm.get('physicalLifestyle.smokingDuration')?.value
          "
        >
          <p class="text-white fs-5 fw-semibold" style="padding-top: 2px">
            {{ "patientCreate.form.packYearFormula" | translate }}:
            {{
              ((patientForm.get("physicalLifestyle.smokingAmount")?.value ||
                0) /
                20) *
                (patientForm.get("physicalLifestyle.smokingDuration")?.value ||
                  0) | number: "1.2-2"
            }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Medical History Section - Placeholder for now -->
  <div class="col-12">
    <div class="card bg-darker p-5">
      <div class="card-title text-white mb-2 d-flex align-items-center">
        <div class="icon-wrapper me-3">
          <i class="fs-4 fas fa-notes-medical"></i>
        </div>
        <div>
          <h5 class="mb-0">
            {{ "patientCreate.medicalHistoryTitle" | translate }}
          </h5>
          <p class="text-muted fs-12 mb-0 mt-1">
            {{
              "patientCreate.medicalHistory.completeMedicalBackgroundInformation"
                | translate
            }}
          </p>
        </div>
      </div>
      <div class="gradient-divider mb-4"></div>

      <div formGroupName="medicalHistory">
        <div class="medical-accordion">
          <!-- Chronic Conditions -->
          <div class="accordion-card mb-3">
            <div
              class="accordion-header-custom"
              [class.expanded]="accordionState.chronicConditions"
              (click)="onToggleAccordion('chronicConditions')"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <div>
                    <h6 class="mb-0">
                      {{ "patientCreate.form.chronicConditions" | translate }}
                    </h6>
                    <span class="accordion-subtitle">{{
                      "patientCreate.medicalHistory.longTermHealthConditions"
                        | translate
                    }}</span>
                  </div>
                </div>
                <i
                  class="fas fa-chevron-down accordion-chevron"
                  [class.rotated]="accordionState.chronicConditions"
                ></i>
              </div>
            </div>

            <div
              class="accordion-content"
              [class.show]="accordionState.chronicConditions"
            >
              <div>
                <div class="autocomplete-wrapper">
                  <div class="chronic-header">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="searchTerm"
                      (focus)="showDropdown = results.length > 0"
                      (input)="onSearchInput($event)"
                      [placeholder]="
                        'patientCreate.medicalHistory.search' | translate
                      "
                    />

                    <ul class="autocomplete-list portal" *ngIf="showDropdown">
                      <li
                        *ngFor="let item of results; trackBy: trackByCode"
                        (click)="onSelectChronicCondition(item)"
                      >
                        <span class="code">{{ item.code }}</span> -
                        <span class="name">{{ item.name }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="selected-conditions"
                  *ngIf="chronicConditionArray.length > 0"
                >
                  <div
                    class="condition-chip"
                    *ngFor="let item of chronicConditionArray; let i = index"
                  >
                    <span class="chip-content">
                      <span class="chip-code">{{ item.code }}</span>
                      <span class="chip-name">{{ item.name }}</span>
                    </span>
                    <button
                      type="button"
                      class="chip-remove"
                      (click)="onRemoveChronicCondition(i)"
                      aria-label="Remove"
                    >
                      ×
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Surgeries -->
          <div class="accordion-card mb-3">
            <div
              class="accordion-header-custom"
              [class.expanded]="accordionState.surgeries"
              (click)="onToggleAccordion('surgeries')"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <div>
                    <h6 class="mb-0">
                      {{ "patientCreate.form.surgeries" | translate }}
                    </h6>
                    <span class="accordion-subtitle">{{
                      "patientCreate.medicalHistory.previousSurgicalProcedures"
                        | translate
                    }}</span>
                  </div>
                </div>
                <i
                  class="fas fa-chevron-down accordion-chevron"
                  [class.rotated]="accordionState.surgeries"
                ></i>
              </div>
            </div>
            <div
              class="accordion-content"
              [class.show]="accordionState.surgeries"
            >
              <div class="nested-accordion">
                <div
                  class="nested-card mb-2"
                  *ngFor="let category of surgeries; let i = index"
                >
                  <div
                    class="nested-header"
                    [class.expanded]="category.isOpen"
                    (click)="category.isOpen = !category.isOpen"
                  >
                    <span class="nested-title">{{ category.name }}</span>
                    <i
                      class="fas fa-chevron-right nested-chevron"
                      [class.rotated]="category.isOpen"
                    ></i>
                  </div>
                  <div class="nested-content" [class.show]="category.isOpen">
                    <div class="checkbox-grid">
                      <ng-container
                        *ngFor="let subCategory of category.subCategories"
                      >
                        <div
                          class="checkbox-item"
                          *ngFor="let surgery of subCategory.surgeries"
                        >
                          <input
                            class="styled-checkbox"
                            type="checkbox"
                            [id]="'surgery-' + surgery.id"
                            [checked]="isSurgerySelected(surgery.id)"
                            (change)="onToggleSurgery(surgery.id)"
                          />
                          <label
                            class="styled-label"
                            [for]="'surgery-' + surgery.id"
                          >
                            {{ surgery.name }}
                          </label>
                        </div>
                      </ng-container>
                    </div>
                    <div
                      class="empty-state"
                      *ngIf="category.subCategories.length === 0"
                    >
                      <i class="fas fa-info-circle me-2"></i>
                      {{
                        "patientCreate.medicalHistory.noSurgeries" | translate
                      }}
                    </div>
                  </div>
                </div>
                <div class="empty-state" *ngIf="surgeries.length === 0">
                  <i class="fas fa-info-circle me-2"></i>
                  {{ "patientCreate.medicalHistory.noSurgeries" | translate }}
                </div>
              </div>
            </div>
          </div>

          <!-- Allergies -->
          <div class="accordion-card mb-3">
            <div
              class="accordion-header-custom"
              [class.expanded]="accordionState.allergies"
              (click)="onToggleAccordion('allergies')"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <div>
                    <h6 class="mb-0">
                      {{ "patientCreate.form.allergies" | translate }}
                    </h6>
                    <span class="accordion-subtitle">{{
                      "patientCreate.medicalHistory.knownAllergicReactions"
                        | translate
                    }}</span>
                  </div>
                </div>
                <i
                  class="fas fa-chevron-down accordion-chevron"
                  [class.rotated]="accordionState.allergies"
                ></i>
              </div>
            </div>
            <div
              class="accordion-content"
              [class.show]="accordionState.allergies"
            >
              <div class="nested-accordion">
                <div
                  class="nested-card mb-2"
                  *ngFor="let category of allergyCategories; let i = index"
                >
                  <div
                    class="nested-header"
                    [class.expanded]="category.isOpen"
                    (click)="category.isOpen = !category.isOpen"
                  >
                    <span class="nested-title">{{
                      category.categoryName
                    }}</span>
                    <i
                      class="fas fa-chevron-right nested-chevron"
                      [class.rotated]="category.isOpen"
                    ></i>
                  </div>
                  <div class="nested-content" [class.show]="category.isOpen">
                    <div class="checkbox-grid">
                      <div
                        class="checkbox-item"
                        *ngFor="let item of category.items"
                      >
                        <input
                          class="styled-checkbox"
                          type="checkbox"
                          [id]="'allergy-' + item.id"
                          [checked]="isAllergySelected(item.id)"
                          (change)="onToggleAllergy(item.id)"
                        />
                        <label
                          class="styled-label"
                          [for]="'allergy-' + item.id"
                        >
                          {{ item.name }}
                        </label>
                      </div>
                      <div
                        class="empty-state"
                        *ngIf="category.items.length === 0"
                      >
                        <i class="fas fa-info-circle me-2"></i>
                        {{
                          "patientCreate.medicalHistory.noItemsInThisCategory"
                            | translate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="empty-state" *ngIf="allergyCategories.length === 0">
                  <i class="fas fa-info-circle me-2"></i>
                  {{ "patientCreate.medicalHistory.noAllergies" | translate }}
                </div>
              </div>
            </div>
          </div>

          <!-- Family History -->
          <div class="accordion-card mb-3">
            <div
              class="accordion-header-custom"
              [class.expanded]="accordionState.familyHistory"
              (click)="onToggleAccordion('familyHistory')"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <div>
                    <h6 class="mb-0">
                      {{ "patientCreate.form.familyHistory" | translate }}
                    </h6>
                    <span class="accordion-subtitle">{{
                      "patientCreate.medicalHistory.familyMedicalBackground"
                        | translate
                    }}</span>
                  </div>
                </div>
                <i
                  class="fas fa-chevron-down accordion-chevron"
                  [class.rotated]="accordionState.familyHistory"
                ></i>
              </div>
            </div>
            <div
              class="accordion-content"
              [class.show]="accordionState.familyHistory"
            >
              <div class="checkbox-grid">
                <div
                  class="checkbox-item"
                  *ngFor="let item of familyMedicalHistory"
                >
                  <input
                    class="styled-checkbox"
                    type="checkbox"
                    [id]="'familyMed-' + item.id"
                    [checked]="isFamilyHistorySelected(item.id)"
                    (change)="onToggleFamilyHistory(item.id)"
                  />
                  <label class="styled-label" [for]="'familyMed-' + item.id">
                    {{ item.name }}
                  </label>
                </div>
                <div
                  class="empty-state"
                  *ngIf="familyMedicalHistory.length === 0"
                >
                  <i class="fas fa-info-circle me-2"></i>
                  {{
                    "patientCreate.medicalHistory.noFamilyHistory" | translate
                  }}
                </div>
              </div>
            </div>
          </div>

          <!-- Immunizations -->
          <div class="accordion-card mb-3">
            <div
              class="accordion-header-custom"
              [class.expanded]="accordionState.immunizations"
              (click)="onToggleAccordion('immunizations')"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <div>
                    <h6 class="mb-0">
                      {{ "patientCreate.form.immunizations" | translate }}
                    </h6>
                    <span class="accordion-subtitle">{{
                      "patientCreate.medicalHistory.vaccinationRecords"
                        | translate
                    }}</span>
                  </div>
                </div>
                <i
                  class="fas fa-chevron-down accordion-chevron"
                  [class.rotated]="accordionState.immunizations"
                ></i>
              </div>
            </div>
            <div
              class="accordion-content"
              [class.show]="accordionState.immunizations"
            >
              <div class="checkbox-grid">
                <div
                  class="checkbox-item"
                  *ngFor="let item of immunizationStatus"
                >
                  <input
                    class="styled-checkbox"
                    type="checkbox"
                    [id]="'immunization-' + item.id"
                    [checked]="isImmunizationSelected(item.id)"
                    (change)="onToggleImmunization(item.id)"
                  />
                  <label class="styled-label" [for]="'immunization-' + item.id">
                    {{ item.name }}
                  </label>
                </div>
                <div
                  class="empty-state"
                  *ngIf="immunizationStatus.length === 0"
                >
                  <i class="fas fa-info-circle me-2"></i>
                  {{
                    "patientCreate.medicalHistory.noImmunizations" | translate
                  }}
                </div>
              </div>
            </div>
          </div>

          <!-- Medications -->
          <div class="accordion-card mb-3">
            <div
              class="accordion-header-custom"
              [class.expanded]="accordionState.medications"
              (click)="onToggleAccordion('medications')"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <div>
                    <h6 class="mb-0">
                      {{
                        "patientCreate.medicalHistory.medications" | translate
                      }}
                    </h6>
                    <span class="accordion-subtitle">{{
                      "patientCreate.medicalHistory.currentMedications"
                        | translate
                    }}</span>
                  </div>
                </div>
                <i
                  class="fas fa-chevron-down accordion-chevron"
                  [class.rotated]="accordionState.medications"
                ></i>
              </div>
            </div>
            <div
              class="accordion-content"
              [class.show]="accordionState.medications"
            >
              <div class="nested-accordion">
                <div
                  class="nested-card mb-2"
                  *ngFor="let category of medications; let i = index"
                >
                  <div
                    class="nested-header"
                    [class.expanded]="category.isOpen"
                    (click)="category.isOpen = !category.isOpen"
                  >
                    <span class="nested-title">{{
                      category.categoryName
                    }}</span>
                    <i
                      class="fas fa-chevron-right nested-chevron"
                      [class.rotated]="category.isOpen"
                    ></i>
                  </div>
                  <div class="nested-content" [class.show]="category.isOpen">
                    <!-- Nested SubCategories -->
                    <div
                      class="nested-sub-accordion ps-3"
                      *ngIf="category.subCategories?.length"
                    >
                      <div
                        class="nested-card mb-2"
                        *ngFor="let subCategory of category.subCategories"
                      >
                        <div
                          class="nested-header"
                          [class.expanded]="subCategory.isOpen"
                          (click)="subCategory.isOpen = !subCategory.isOpen"
                        >
                          <span class="nested-title">{{
                            subCategory.subCategoryName
                          }}</span>
                          <i
                            class="fas fa-chevron-right nested-chevron"
                            [class.rotated]="subCategory.isOpen"
                          ></i>
                        </div>
                        <div
                          class="nested-content"
                          [class.show]="subCategory.isOpen"
                        >
                          <div class="checkbox-grid">
                            <div
                              class="checkbox-item"
                              *ngFor="let medication of subCategory.medications"
                            >
                              <input
                                class="styled-checkbox"
                                type="checkbox"
                                [id]="'medication-' + medication.id"
                                [checked]="isMedicationSelected(medication.id)"
                                (change)="onToggleMedication(medication.id)"
                              />
                              <label
                                class="styled-label"
                                [for]="'medication-' + medication.id"
                              >
                                {{ medication.name }}
                              </label>
                            </div>
                            <div
                              class="empty-state"
                              *ngIf="!subCategory.medications?.length"
                            >
                              <i class="fas fa-info-circle me-2"></i>
                              {{
                                "patientCreate.medicalHistory.noMedications"
                                  | translate
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Fallback for direct medications (if any, though API changed) -->
                    <div
                      class="checkbox-grid"
                      *ngIf="!category.subCategories?.length"
                    >
                      <div
                        class="checkbox-item"
                        *ngFor="let medication of category.medications"
                      >
                        <input
                          class="styled-checkbox"
                          type="checkbox"
                          [id]="'medication-' + medication.id"
                          [checked]="isMedicationSelected(medication.id)"
                          (change)="onToggleMedication(medication.id)"
                        />
                        <label
                          class="styled-label"
                          [for]="'medication-' + medication.id"
                        >
                          {{ medication.name }}
                        </label>
                      </div>
                      <div
                        class="empty-state"
                        *ngIf="category.medications?.length === 0"
                      >
                        <i class="fas fa-info-circle me-2"></i>
                        {{
                          "patientCreate.medicalHistory.noMedications"
                            | translate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="empty-state" *ngIf="medications.length === 0">
                  <i class="fas fa-info-circle me-2"></i>
                  {{ "patientCreate.medicalHistory.noMedications" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
